var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    { staticClass: "left-nav", class: { "left-nav--open": _vm.navMenuOpen } },
    [
      _c(
        "div",
        {
          staticClass: "left-nav__menu",
          class: { "left-nav__menu--open": _vm.navMenuOpen }
        },
        [
          _vm.hasPrivilege(_vm.privileges.CAMPAIGNS)
            ? _c(
                "a",
                {
                  staticClass: "left-nav__link",
                  on: { click: _vm.handleClickCreateCampaign }
                },
                [
                  _c("div", {
                    staticClass:
                      "left-nav__link-icon mdi mdi-pencil-box-outline"
                  }),
                  _c("div", { staticClass: "left-nav__link-text" }, [
                    _vm._v("CREATE")
                  ])
                ]
              )
            : _vm._e(),
          _vm.hasPrivilege(_vm.privileges.CAMPAIGNS)
            ? _c(
                "a",
                {
                  staticClass: "left-nav__link",
                  class: {
                    "left-nav__link--active":
                      _vm.get(_vm.$route, "matched[0].name") === "campaigns",
                    "left-nav__link--disabled": _vm.processing
                  },
                  on: {
                    click: function($event) {
                      return _vm.navigate("campaigns")
                    }
                  }
                },
                [
                  _c("div", {
                    staticClass: "left-nav__link-icon icon-campaigns"
                  }),
                  _c("div", { staticClass: "left-nav__link-text" }, [
                    _vm._v("CAMPAIGNS")
                  ])
                ]
              )
            : _vm._e(),
          _vm.hasPrivilege(_vm.privileges.ORDERS)
            ? _c(
                "a",
                {
                  staticClass: "left-nav__link",
                  class: {
                    "left-nav__link--active":
                      _vm.get(_vm.$route, "matched[0].name") === "orders",
                    "left-nav__link--disabled": _vm.processing
                  },
                  on: {
                    click: function($event) {
                      return _vm.navigate("orders")
                    }
                  }
                },
                [
                  _c("div", {
                    staticClass: "left-nav__link-icon mdi mdi-cart"
                  }),
                  _c("div", { staticClass: "left-nav__link-text" }, [
                    _vm._v("ORDERS")
                  ])
                ]
              )
            : _vm._e(),
          _vm.hasPrivilege(_vm.privileges.PROMOTIONS)
            ? _c(
                "a",
                {
                  staticClass: "left-nav__link",
                  class: {
                    "left-nav__link--active":
                      _vm.get(_vm.$route, "matched[0].name") === "promotions",
                    "left-nav__link--disabled": _vm.processing
                  },
                  on: {
                    click: function($event) {
                      return _vm.navigate("promotions")
                    }
                  }
                },
                [
                  _c("div", {
                    staticClass: "left-nav__link-icon mdi mdi-ticket-percent"
                  }),
                  _c("div", { staticClass: "left-nav__link-text" }, [
                    _vm._v("COUPONS")
                  ])
                ]
              )
            : _vm._e(),
          _vm.hasPrivilege(_vm.privileges.STORES)
            ? _c(
                "a",
                {
                  staticClass: "left-nav__link",
                  class: {
                    "left-nav__link--active":
                      _vm.get(_vm.$route, "matched[0].name") === "stores",
                    "left-nav__link--disabled": _vm.processing
                  },
                  on: {
                    click: function($event) {
                      return _vm.navigate("stores")
                    }
                  }
                },
                [
                  _c("div", {
                    staticClass: "left-nav__link-icon icon-collections"
                  }),
                  _c("div", { staticClass: "left-nav__link-text" }, [
                    _vm._v("COLLECTIONS")
                  ])
                ]
              )
            : _vm._e(),
          _vm.hasPrivilege(_vm.privileges.ACADEMY)
            ? _c(
                "a",
                {
                  staticClass: "left-nav__link",
                  attrs: {
                    href: "http://sellers.viralstyle.com",
                    target: "_blank"
                  },
                  on: { click: _vm.closeMenu }
                },
                [
                  _c("div", {
                    staticClass: "left-nav__link-icon mdi mdi-school"
                  }),
                  _c("div", { staticClass: "left-nav__link-text" }, [
                    _vm._v("ACADEMY")
                  ])
                ]
              )
            : _vm._e(),
          _vm.permissionViewPayouts
            ? _c(
                "a",
                {
                  staticClass: "left-nav__link",
                  class: {
                    "left-nav__link--active":
                      _vm.get(_vm.$route, "matched[1].name") ===
                      "settingsPayouts",
                    "left-nav__link--disabled": _vm.processing
                  },
                  on: {
                    click: function($event) {
                      return _vm.navigate("settingsPayouts")
                    }
                  }
                },
                [
                  _c("div", {
                    staticClass: "left-nav__link-icon mdi mdi-cash"
                  }),
                  _c("div", { staticClass: "left-nav__link-text" }, [
                    _vm._v("PAYOUTS")
                  ])
                ]
              )
            : _vm._e(),
          _vm.permissionAccessDomains
            ? _c(
                "a",
                {
                  staticClass: "left-nav__link",
                  class: {
                    "left-nav__link--active":
                      _vm.get(_vm.$route, "matched[0].name") === "domains",
                    "left-nav__link--disabled": _vm.processing
                  },
                  on: {
                    click: function($event) {
                      return _vm.navigate("domains")
                    }
                  }
                },
                [
                  _c("div", {
                    staticClass: "left-nav__link-icon mdi mdi-store"
                  }),
                  _c("div", { staticClass: "left-nav__link-text" }, [
                    _vm._v("DOMAINS")
                  ])
                ]
              )
            : _vm._e(),
          _vm.hasPrivilege(_vm.privileges.SETTINGS_NAV)
            ? _c(
                "a",
                {
                  staticClass: "left-nav__link",
                  class: {
                    "left-nav__link--active":
                      _vm.get(_vm.$route, "matched[0].name") === "settings" &&
                      _vm.get(_vm.$route, "matched[1].name") !==
                        "settingsPayouts",
                    "left-nav__link--disabled": _vm.processing
                  },
                  on: {
                    click: function($event) {
                      return _vm.navigate("settings")
                    }
                  }
                },
                [
                  _c("div", {
                    staticClass: "left-nav__link-icon mdi mdi-settings"
                  }),
                  _c("div", { staticClass: "left-nav__link-text" }, [
                    _vm._v("SETTINGS")
                  ])
                ]
              )
            : _vm._e(),
          _vm.showMyOrdersLink
            ? _c(
                "a",
                {
                  staticClass: "left-nav__link left-nav__mobile",
                  attrs: { target: "_blank", href: _vm.profileUrl }
                },
                [
                  _c("div", {
                    staticClass: "left-nav__link-icon mdi mdi-cart"
                  }),
                  _c("div", { staticClass: "left-nav__link-text" }, [
                    _vm._v("MY ORDERS")
                  ])
                ]
              )
            : _vm._e(),
          _c(
            "a",
            {
              staticClass: "left-nav__link left-nav__mobile",
              on: { click: _vm.handleLogout }
            },
            [
              _c("div", { staticClass: "left-nav__link-icon mdi mdi-logout" }),
              _c("div", { staticClass: "left-nav__link-text" }, [
                _vm._v("LOG OUT")
              ])
            ]
          )
        ]
      ),
      _c("div", {
        staticClass: "left-nav__block",
        class: { "left-nav__block--open": _vm.navMenuOpen },
        on: { click: _vm.closeMenu }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }